export default __webpack_public_path__ + "static/media/TurnPhoneIcon.0979aad5.svg";